import { createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "col-xs-12 col-sm-12"
};
const _hoisted_2 = {
    class: "row",
    style: { "max-height": "calc(100vh - 250px)", "min-height": "300px" }
};
const _hoisted_3 = { class: "text-center bottom10" };
const _hoisted_4 = { class: "col-xs-4 col-sm-4 col-md-4 tile_stats_count" };
const _hoisted_5 = { class: "fs-3 fw-bold" };
const _hoisted_6 = { class: "col-xs-4 col-sm-4 col-md-4 tile_stats_count healthy" };
const _hoisted_7 = { class: "fs-3 fw-bold" };
const _hoisted_8 = { class: "col-xs-4 col-sm-4 col-md-4 tile_stats_count critical" };
const _hoisted_9 = { class: "fs-3 fw-bold" };
const _hoisted_10 = {
    key: 0,
    class: "alert alert-warning",
    role: "alert"
};
const _hoisted_11 = {
    class: "list-filter",
    style: { "min-height": "260px", "height": "50vh", "overflow-x": "auto", "background-color": "whitesmoke" }
};
const _hoisted_12 = { class: "table table-sm table-hover mb-0" };
const _hoisted_13 = { style: { "width": "30px", "vertical-align": "middle" } };
const _hoisted_14 = {
    key: 0,
    class: "fa fa-check text-success"
};
const _hoisted_15 = {
    key: 1,
    class: "fa fa-times text-danger"
};
const _hoisted_16 = { class: "fw-bold" };
const _hoisted_17 = { class: "text-muted" };
const _hoisted_18 = { key: 0 };
const _hoisted_19 = {
    key: 1,
    class: "text-muted small mt-2"
};
const _hoisted_20 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        class: "modal-form-lg",
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.show) = $event)),
        "header-bg-variant": "normal",
        size: "lg"
    }, {
        title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("\r\n\t\t\tSystem Coverage\r\n\t\t", -1 /* CACHED */)
            ]))]),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "secondary",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.show = false))
                }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                            _createTextVNode(" Close\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        default: _withCtx(() => [
            _cache[24] || (_cache[24] = _createTextVNode()),
            _createVNode(_component_b_container, { clearfix: "" }, {
                default: _withCtx(() => {
                    var _a, _b, _c, _d, _e, _f;
                    return [
                        (_ctx.loaded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createCommentVNode(" Summary Stats "),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("a", null, _toDisplayString((_b = (_a = _ctx.systemCoverage) === null || _a === void 0 ? void 0 : _a.totalSystemCount) !== null && _b !== void 0 ? _b : 0), 1 /* TEXT */)
                                            ]),
                                            _cache[4] || (_cache[4] = _createTextVNode()),
                                            _cache[5] || (_cache[5] = _createElementVNode("small", { class: "text-muted" }, "Total", -1 /* CACHED */))
                                        ]),
                                        _cache[10] || (_cache[10] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("a", null, _toDisplayString((_d = (_c = _ctx.systemCoverage) === null || _c === void 0 ? void 0 : _c.licensedSystemCount) !== null && _d !== void 0 ? _d : 0), 1 /* TEXT */)
                                            ]),
                                            _cache[6] || (_cache[6] = _createTextVNode()),
                                            _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-muted" }, "Licensed", -1 /* CACHED */))
                                        ]),
                                        _cache[11] || (_cache[11] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("a", null, _toDisplayString((_f = (_e = _ctx.systemCoverage) === null || _e === void 0 ? void 0 : _e.unlicensedSystemCount) !== null && _f !== void 0 ? _f : 0), 1 /* TEXT */)
                                            ]),
                                            _cache[8] || (_cache[8] = _createTextVNode()),
                                            _cache[9] || (_cache[9] = _createElementVNode("small", { class: "text-muted" }, "Unlicensed", -1 /* CACHED */))
                                        ])
                                    ]),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    _createCommentVNode(" Systems List "),
                                    _cache[22] || (_cache[22] = _createTextVNode()),
                                    _createElementVNode("div", null, [
                                        (_ctx.hasUnlicensedSystems)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "\r\n                            Systems not covered by the license will be excluded from restricted features.\r\n\t\t\t\t\t\t"))
                                            : _createCommentVNode("v-if", true),
                                        _cache[17] || (_cache[17] = _createTextVNode()),
                                        _createElementVNode("div", null, [
                                            _createVNode(_component_b_form_input, {
                                                modelValue: _ctx.systemsFilter,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.systemsFilter) = $event)),
                                                modelModifiers: { trim: true },
                                                placeholder: "Search for..."
                                            }, null, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("table", _hoisted_12, [
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSystems, (system) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: system.systemId
                                                        }, [
                                                            _createElementVNode("td", _hoisted_13, [
                                                                (system.isLicensed)
                                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                                                                    : (_openBlock(), _createElementBlock("i", _hoisted_15))
                                                            ]),
                                                            _cache[14] || (_cache[14] = _createTextVNode()),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("div", _hoisted_16, _toDisplayString(system.systemName), 1 /* TEXT */),
                                                                _cache[13] || (_cache[13] = _createTextVNode()),
                                                                _createElementVNode("div", null, [
                                                                    _createElementVNode("small", null, _toDisplayString(system.companyName), 1 /* TEXT */),
                                                                    _cache[12] || (_cache[12] = _createTextVNode()),
                                                                    _createElementVNode("small", _hoisted_17, " - " + _toDisplayString(system.siteName), 1 /* TEXT */)
                                                                ])
                                                            ])
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    _cache[16] || (_cache[16] = _createTextVNode()),
                                                    (_ctx.filteredSystems.length === 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[15] || (_cache[15] = [
                                                                _createElementVNode("td", {
                                                                    colspan: "2",
                                                                    class: "text-center text-muted py-3"
                                                                }, "\r\n\t\t\t\t\t\t\t\t\t\t\tNo systems match your search.\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                            ]))]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ]),
                                        _cache[19] || (_cache[19] = _createTextVNode()),
                                        (_ctx.systemCoverage && _ctx.systemCoverage.systems.length > _ctx.filteredSystems.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, "\r\n\t\t\t\t\t\t\tShowing " + _toDisplayString(_ctx.filteredSystems.length) + " of " + _toDisplayString(_ctx.systemCoverage.systems.length) + " systems\r\n\t\t\t\t\t\t", 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ];
                }),
                _: 1 /* STABLE */
            }),
            _cache[25] || (_cache[25] = _createTextVNode())
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]));
}
